import {type SmoothingType} from '../../../generated/graphql';
import {smoothLines} from '../../../util/plotHelpers/lines';
import {type LineWithSource} from '../../../util/plotHelpers/types';

export function getFrontendSmoothedLinesForDisplay<T extends LineWithSource>(
  lines: T[],
  smoothingParam: number,
  smoothingType: SmoothingType,
  showOriginalAfterSmoothing: boolean
): T[] {
  const [originalLinesAsAux, smoothedOrRetainedLines] = smoothLines(
    lines,
    smoothingParam,
    smoothingType
  );

  if (!showOriginalAfterSmoothing) {
    return smoothedOrRetainedLines;
  }

  // Area lines are already retained in smoothedOrRetainedLines. Show Original
  // only controls unsmoothed line overlays.
  const originalLineOverlays = originalLinesAsAux.filter(
    line => line.meta.type === 'line'
  );

  return [...smoothedOrRetainedLines, ...originalLineOverlays];
}
